import { doc, getFirestore, updateDoc } from "firebase/firestore";
import { BroadcastToUpdate } from "../types";

export const updateBroadcast = async (
  broadcastId: string,
  broadcast: BroadcastToUpdate,
) => {
  const db = getFirestore();
  const docRef = doc(db, "broadcasts", broadcastId);

  await updateDoc(docRef, {
    ...broadcast,
    updatedAt: new Date(),
  });

  return { id: broadcastId };
};
